export { Tabs } from './tabs';

export type { TabsProps, TabsStylesNames } from './tabs';
export type { TabsPanelProps } from './tabs-panel/tabs-panel';
export type { TabProps } from './tab/tab';
export type { TabsListProps } from './tabs-list/tabs-list';
export type { TabsStylesParams, TabsOrientation, TabsValue, TabsVariant } from './tabs.types';
